<template>
  <el-form-item>
    <template v-slot:label>
      <span
        >{{ i18nt('designer.setting.validation') }}
        <el-tooltip effect="light" :content="i18nt('designer.setting.validationHelp')"> <i class="el-icon-info"></i></el-tooltip>
      </span>
    </template>
    <el-select v-model="optionModel.validation" filterable clearable allow-create default-first-option>
      <el-option v-for="(fv, fvIdx) in fieldValidators" :key="fvIdx" :label="fv.label" :value="fv.value"> </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { reactive, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useProperty } from '@/components/form-designer/setting-panel/property-editor/propertyMixin';

export default {
  name: 'validation-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const properyMixins = useProperty();

    const data = reactive({
      fieldValidators: [
        { label: i18nt('designer.hint.numberValidator'), value: 'number' },
        { label: i18nt('designer.hint.letterValidator'), value: 'letter' },
        { label: i18nt('designer.hint.letterAndNumberValidator'), value: 'letterAndNumber' },
        { label: i18nt('designer.hint.mobilePhoneValidator'), value: 'mobilePhone' },
        { label: i18nt('designer.hint.emailValidator'), value: 'email' },
        { label: i18nt('designer.hint.urlValidator'), value: 'url' },
        { label: i18nt('designer.hint.noChineseValidator'), value: 'noChinese' },
        { label: i18nt('designer.hint.chineseValidator'), value: 'chinese' },
      ],
    });

    return {
      i18nt,
      ...toRefs(props),
      ...properyMixins,
      ...data,
    };
  },
};
</script>

<style scoped></style>
